import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import "firebase/firestore";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { Catalog } from "../models/product.model";

@Injectable({
  providedIn: "root",
})
export class CatalogService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Catalog>;

  constructor(private db: AngularFirestore, private userStore: UserService) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getCatalogs(shopId: string): AngularFirestoreCollection<Catalog> {
    return this.db.collection(this.dbPath + `/${shopId}/catalogs`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .orderBy("updatedOn", "desc")
    );
  }

  getCatalogsByMode(
    shopId: string,
    mode: string
  ): AngularFirestoreCollection<Catalog> {
    return this.db.collection(this.dbPath + `/${shopId}/catalogs`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("mode", "==", mode)
        .orderBy("updatedOn", "desc")
    );
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/catalogs`)
      .doc(id)
      .valueChanges();
  }

  create(catalog: Catalog): any {
    catalog.isActive = true;
    catalog.isDeleted = false;
    catalog.createdOn = new Date();
    catalog.createdBy = this.userLogin.uid;
    catalog.updatedOn = new Date();
    catalog.updatedBy = this.userLogin.uid;
    catalog.visibility = this.visibility;
    catalog.timestamp = new Date().getTime();

    catalog.shopId = catalog.shopId ? catalog.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${catalog.shopId}/catalogs`
    );

    return this.collRef.add({ ...catalog }).then((docRef) => {
      catalog.id = docRef.id;
      return catalog;
    });
  }

  update(catalog: Catalog): Promise<void> {
    console.log("update catalog:", catalog);

    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${catalog.shopId}/catalogs`
    );
    return this.collRef.doc(catalog.id).update({
      title: catalog.title,
      description: catalog.description ? catalog.description : "",
      coverUrl: catalog.coverUrl ? catalog.coverUrl : "",
      tags: catalog.tags ? catalog.tags : [],
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/catalogs`);
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
